import React from 'react';
import IconOne from '../../assets/images/icon/1.png';
import IconTwo from '../../assets/images/icon/2.png';
import IconThree from '../../assets/images/icon/3.png';
import IconFour from '../../assets/images/icon/4.png';

function WhyOurApp({ className }) {
    return (
        <section className={`moelist-service-area pt-90 pb-100 ${className}`} id="service">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="moelist-section-title text-center">
                            <h3 className="moelist-title">
                                Why should you
                                <br />
                                use our app?
                            </h3>
                            <p>Reasons to download and use our app</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="moelist-single-service text-center mt-30 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <div className="icon">
                                <img src={IconOne} alt="" />
                                <span>1</span>
                            </div>
                            <h4 className="moelist-title">Updated</h4>
                            <p>
                                MoeList is under constant development, so that we can give you the
                                best app experience without any bugs. Post suggestions in Discord
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="moelist-single-service text-center mt-30 item-2 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="400ms"
                        >
                            <div className="icon">
                                <img src={IconTwo} alt="" />
                                <span>2</span>
                            </div>
                            <h4 className="moelist-title">Design</h4>
                            <p>
                                MoeList has a nice design, which is very easy to understand. You can
                                also decide if you want to use the Light or Dark Theme.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="moelist-single-service text-center mt-30 item-3 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="600ms"
                        >
                            <div className="icon">
                                <img src={IconThree} alt="" />
                                <span>3</span>
                            </div>
                            <h4 className="moelist-title">Secure</h4>
                            <p>
                                We do not collect any login data! - everything is securely
                                transferred from MyAnimeList to MoeList using SSL encryption.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div
                            className="moelist-single-service text-center mt-30 item-4 wow animated fadeInUp"
                            data-wow-duration="2000ms"
                            data-wow-delay="800ms"
                        >
                            <div className="icon">
                                <img src={IconFour} alt="" />
                                <span>4</span>
                            </div>
                            <h4 className="moelist-title">Support</h4>
                            <p>
                                We offer fast support, so we can answer your questions quickly and
                                reliably. You can also ask your problem or question to our
                                community.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WhyOurApp;
